import { createAction } from 'redux-actions';
export const appInit = createAction('@@app/APP_INIT');